module.exports = __webpack_public_path__ + "img/pota-4.a423b6d1.png";